import {ChangeDetectorRef, Component, OnDestroy} from "@angular/core";
import {FUINavLayoutService} from "../../nav-layout/nav-layout.service";
import {FUINavigationService} from "../../navigation/navigation.service";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-canvas-frame",
    styleUrls: ["./canvas-frame.component.scss"],
    templateUrl: "./canvas-frame.component.html",
    host: {
        "[class.active]": "active",
        "[class.mobile]": "navigationService.useMobileNav()"
    },
    standalone: false
})
export class FUICanvasFrameComponent implements OnDestroy {
    public active: boolean = false;
    private subscriptions: Subscription = new Subscription();

    constructor(public navigationService: FUINavigationService,
                public navLayoutService: FUINavLayoutService,
                private changeDetectorRef: ChangeDetectorRef) {
        this.subscriptions.add(this.navLayoutService.activeFrame$.subscribe((active) => setTimeout(() => {
            this.active = active;
            this.changeDetectorRef.markForCheck();
        })));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
